import { render, staticRenderFns } from "./BankBranchTable.vue?vue&type=template&id=7f791b9e&scoped=true"
import script from "./BankBranchTable.vue?vue&type=script&lang=js"
export * from "./BankBranchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f791b9e",
  null
  
)

export default component.exports